module.exports = __webpack_public_path__ + "static/media/elios_logo.4443de62.png";